import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-green-deep text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <h2 className="text-2xl font-bold text-gold-primary mb-6">VSK ASSOCIATES</h2>
            <p className="text-gray-300 mb-6 italic">{t('footer.description')}</p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-gold-primary transition-colors"><FaFacebookF size={20} /></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="hover:text-gold-primary transition-colors"><FaTwitter size={20} /></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-gold-primary transition-colors"><FaInstagram size={20} /></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="hover:text-gold-primary transition-colors"><FaLinkedinIn size={20} /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 border-b border-gold-primary pb-2 inline-block">{t('footer.quickLinks')}</h3>
            <ul className="space-y-4 text-gray-300">
              <li><Link to="/" className="hover:text-gold-primary transition-colors">{t('nav.home')}</Link></li>
              <li><Link to="/about" className="hover:text-gold-primary transition-colors">{t('nav.about')}</Link></li>
              <li><Link to="/services" className="hover:text-gold-primary transition-colors">{t('nav.services')}</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-gold-primary transition-colors">{t('footer.privacy')}</Link></li>
              <li><Link to="/terms-conditions" className="hover:text-gold-primary transition-colors">{t('footer.terms')}</Link></li>
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h3 className="text-lg font-bold mb-6 border-b border-gold-primary pb-2 inline-block">{t('footer.contactInfo')}</h3>
            <ul className="space-y-4 text-gray-300">
              <li className="flex items-start space-x-3">
                <MapPin className="text-gold-primary flex-shrink-0 mt-1" size={18} />
                <span>Shop No. GF-03, Near PNB, Gorho Chowk, Satarwar, Mahishi, Saharsa, Bihar - 852216</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="text-gold-primary flex-shrink-0" size={18} />
                <div className="flex flex-col">
                  <a href="tel:9136556703" className="hover:text-gold-primary transition-colors">+91 9136556703</a>
                  <a href="tel:8936835037" className="hover:text-gold-primary transition-colors">+91 8936835037</a>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="text-gold-primary flex-shrink-0" size={18} />
                <a href="mailto:vskassociates91665@gmail.com" className="hover:text-gold-primary transition-colors">vskassociates91665@gmail.com</a>
              </li>
            </ul>
          </div>

          {/* Special IT Info (Replacing redundant Services list in footer) */}
          <div>
            <h3 className="text-lg font-bold mb-6 border-b border-gold-primary pb-2 inline-block">{t('services.categories.itDigitalServices.title')}</h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              We offer comprehensive Software, Website, and App development solutions along with Digital Marketing and SEO to grow your business.
            </p>
            <Link to="/services/itDigitalServices" className="mt-4 inline-block text-gold-primary font-bold hover:underline">
              Explore IT Services &rarr;
            </Link>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-16 pt-8 text-center text-sm text-gray-400">
          <p>&copy; {currentYear} VSK ASSOCIATES. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
